export type FormatNumberOptions = {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  nullDisplay?: string;
  /** Default true (Intl default). Ledger historic toFixed(2) used no grouping. */
  useGrouping?: boolean;
};

function coerce(amount: unknown): number | null {
  if (amount === null || amount === undefined) return null;
  if (typeof amount === 'string' && amount.trim() === '') return null;
  const n = typeof amount === 'number' ? amount : Number(amount);
  return Number.isFinite(n) ? n : null;
}

/** Non-money numeric display (counts, KPIs). */
export function formatNumber(value: unknown, options: FormatNumberOptions = {}): string {
  const n = coerce(value);
  if (n === null) return options.nullDisplay ?? '';
  const min = options.minimumFractionDigits ?? 0;
  const max = options.maximumFractionDigits ?? Math.max(min, 0);
  try {
    return new Intl.NumberFormat(options.locale, {
      minimumFractionDigits: min,
      maximumFractionDigits: max,
      useGrouping: options.useGrouping,
    }).format(n);
  } catch {
    return String(n);
  }
}
